import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import media from '../../../utils/mediaQueries';
import { Title } from './Title';
import { MAIN_BLUE } from '../../../theme';
import { Results } from './constants';

const Section = styled.section`
  padding: 0 40px;
  
  ${media.mobile`
    padding: 0;
  `}
`;

const Content = styled.p`
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  margin: 0 0 32px;
  width: 100%;
  max-width: 556px;
  
  ${media.mobile`
    max-width: none;
  `}
`;

const AccountLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  transition: all 0.3s;
  height: 48px;
  padding: 0 24px;
  font-size: 16px;
  border-radius: 4px;
  width: 100%;
  max-width: 272px;
  background-color: ${MAIN_BLUE};
  border: 1px solid ${MAIN_BLUE};
  color: #ffffff; 
  
  &:hover, &:focus {
    opacity: 0.9;
    color: #ffffff; 
    text-decoration: none;
  }
`;

const TEXTS = {
  [Results.Success]: {
    TITLE: 'Votre inscription a été validée !',
    MESSAGE: 'Votre identifiant et le lien de connexion vous ont été envoyés par email. Si vous n’avez rien reçu il est peut-être dans vos courriers indésirables (spam). Vous pouvez également le récupérer à tout moment en vous connectant à votre compte.',
  },
  [Results.Error]: {
    TITLE: 'Oups, un problème est survenu !',
    MESSAGE: 'Il semblerait que nous ayons un problème inattendu. Nous allons contacter l’auto-école pour le résoudre au plus vite. Nous vous invitons à patienter et à réessayer un peu plus tard.',
  },
};

const PaymentResultScreen = ({ result }) => (
  <Section>
    <Title>{TEXTS[result].TITLE}</Title>
    <Content>{TEXTS[result].MESSAGE}</Content>
    {result === Results.Success && <AccountLink href="/student#/code-en-ligne">Accéder à mon compte</AccountLink>}
  </Section>
);

PaymentResultScreen.propTypes = {
  result: PropTypes.string.isRequired,
};

export { PaymentResultScreen };
